module.exports = __webpack_public_path__ + "img/3-3.7dc6af0f.svg";